import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateServicesForm } from "web_myplann/Portfolio/Pages/ServicesCreate/CreateServicesForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddServicesPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddServices.title)}>
			<CreateServicesForm />
		</PortfolioAddLayout>
	);
};
